export const validateAttendances = (data) => {
    if (!data) {
        return false;
    }

    const hasHomeDelivery = data.some(item => item.label === "home_delivery");

    if (hasHomeDelivery) {
        return false;
    }

    return data.length < 1 ||
        data.every(attendanceType => {
            return attendanceType.regions.length < 1;
        });
}
